<template>
  <footer>
    <div class="footer-content">
      <div class="footer-logo-wrapper">
        <logo></logo>
      </div>
      <div>NASHI Corporation © 2011–{{ currentYear }}</div>
      <div>Корпорація «Наші» © 2011–{{ currentYear }}</div>
    </div>
  </footer>
</template>

<script>

import moment from 'moment';

import Logo from '@/components/Logo';

export default {
  name: 'PageFooter',
  components: {
    Logo,
  },
  computed: {
    currentYear() {
      return moment().format('YYYY');
    },
  },
};

</script>

<style scoped>

footer {
  height: 150px;
  font-size: 14px;
  /*color: rgba(0,0,0,.3);*/
  color: #bbb;
  text-align: center;
  display: flex;
  align-items: flex-end;
}

.footer-content {
  /*width: 400px;*/
  margin: 0 auto;
  margin-bottom: 30px;
}

.footer-logo-wrapper {
  width: 80px;
  margin: 0 auto;
}

</style>

<style>
.footer-logo-wrapper svg {
  stroke: #bbb !important;
}
</style>



// WEBPACK FOOTER //
// src/components/PageFooter.vue